import { useContext } from "react";
import { SearchParamsContext } from "../providers/SearchParamsProvider";
import { LinkType, LinkTypes } from "src/contexts/_shared/domain/LinkType";

export function useSlug() {
  const { slug, linkType } = useContext(SearchParamsContext);

  return {
    slug,
    linkType,
    isMagicLink: linkType && linkType.equals(new LinkType(LinkTypes.MAGIC_LINK)),
    isUserLink: linkType && linkType.equals(new LinkType(LinkTypes.USER_LINK)),
  };
}
